import React, { useEffect, useRef, useState } from 'react';
import {
   Box,
   Button,
   Grid,
   IconButton,
   Paper,
   Typography,
   Backdrop,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle';
import { Controller, useForm } from 'react-hook-form';
import { TitleLabel } from '../../../components/Element/LabelInputForm';
import { MySelect } from '../../Select/Select';
import { endOfDay, format } from 'date-fns';
import { th, enUS } from 'date-fns/locale';
import 'react-nice-dates/build/style.css';
import { DatePicker } from 'react-nice-dates';
import { AlertLabel, Input } from '../../../assets/styled/Element';
import LoadingPopup from '../../Loading/LoadingPopup';
import ErrorPopup from '../../Error/ErrorPopup';
import Axios from 'axios';
import { useSnackbar } from 'notistack';
import {
   checkStatusSelect,
   reverseFormatNumber,
} from '../../../configs/helpers/utility';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import dayjs from 'dayjs';

const options = [
   { value: 1, label: 'Active', color: '#4ba23a' },
   { value: 2, label: 'Inactive', color: '#9e9e9e' },
   // { value: 3, label: 'Expire', color: '#ff0000' },
];

const useStyles = makeStyles((theme) => ({
   backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
   },
   paper: {
      padding: theme.spacing(2, 4, 3),
      width: '450px',
      borderRadius: '7.5px',
      maxHeight: '95vh',
      overflow: 'auto',
   },
   role: {
      color: '#5858FA',
   },
   title: {
      color: '#6E6E6E',
   },
   large: {
      width: theme.spacing(8),
      height: theme.spacing(8),
   },
   header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(1, 0),
   },
   content: {
      margin: theme.spacing(0, 1),
      width: '100%',
   },
   headerL: {
      margin: theme.spacing(1),
   },
   listStyle: {
      height: '65px',
   },
   flexGrid: {
      display: 'flex',
      alignItems: 'center',
   },
   qrPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%',
   },
   detailRight: {
      height: '280px',
      overflow: 'auto',
   },
}));
function Edit(props) {
   const classes = useStyles();
   const [data, setData] = useState(props.data);
   const [isLoading, setIsLoading] = useState(false);
   const [isError, setIsError] = useState({
      error: false,
      errorStatus: '',
      errorMessage: '',
   });
   const {
      handleSubmit,
      control,
      register,
      errors,
      watch,
      setValue,
      getValues,
   } = useForm({
      defaultValues: {
         walletCode: data.walletCode,
         pointAmount: new Intl.NumberFormat().format(data.walletCurrentBalance),
         walletNameTh: data.walletNameTh,
         walletNameEn: data.walletNameEn,
         walletDescriptionTh: data.walletDescriptionTh,
         walletDescriptionEn: data.walletDescriptionEn,
         walletExpiredDate: new Date(data.walletExpiryDate),
         walletStatus: checkStatusSelect(data.walletStatus),
      },
   });

   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const closeRef = useRef();
   // const selectWalletExpiredDate = watch('walletExpiredDate'); // old
   const [selectWalletExpiredDate, setSelectWalletExpiredDate] = useState(null); // new
   useEffect(() => {
      register({ name: 'walletExpiredDate' });
   }, [register]);
   const handleWalletExpiredDate = (e) => {
      setValue('walletExpiredDate', endOfDay(e)); // old
      setSelectWalletExpiredDate(endOfDay(e)); // new
   };
   const onSubmit = async (e) => {
      sessionStorage.setItem('value', JSON.stringify(e));
      if (sessionStorage['value']) {
         const values = JSON.parse(sessionStorage.getItem('value'));
         postData(values);
      }
   };
   const postData = (values) => {
      setIsLoading(true);
      const result = {
         walletId: data.walletId,
         // pointAmount: +reverseFormatNumber(values.pointAmount, 'en'),
         pointAmount: null,
         walletNameTh: values.walletNameTh ? values.walletNameTh.trim() : '-',
         walletNameEn: values.walletNameEn ? values.walletNameEn.trim() : '-',
         walletDescriptionTh: values.walletDescriptionTh
            ? values.walletDescriptionTh.trim()
            : '-',
         walletDescriptionEn: values.walletDescriptionEn
            ? values.walletDescriptionEn.trim()
            : '-',
         walletExpiredDate: format(
            new Date(values.walletExpiredDate),
            'dd/MM/yyyy HH:mm:ss',
         ),
         walletStatus: values.walletStatus.value,
      };
      Axios.post('/GSB/dashboard/wallet/EditHRWallet', result)
         .then((resp) => {
            // console.log(resp);
            enqueueSnackbar('แก้ไขรายการสำเร็จ!!', {
               variant: 'success',
            });
            props.onSuccess();
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            sessionStorage.removeItem('value');
            setIsLoading(false);
         });
   };
   if (isError.error)
      return (
         <ErrorPopup
            onClick={props.onClickClose}
            errorStatus={isError.errorStatus}
            errorMessage={isError.errorMessage}
         />
      );
   return (
      <Paper className={classes.paper}>
         <Backdrop className={classes.backdrop} open={isLoading}>
            <LoadingPopup />
         </Backdrop>
         <div className={classes.header}>
            <Typography variant={'h4'}>แก้ไขกระเป๋าส่วนกลาง (HR)</Typography>
            <IconButton
               className={classes.headerL}
               size={'small'}
               onClick={props.onClickClose}
               ref={closeRef}
            >
               <FontAwesomeIcon icon={faTimesCircle} />
            </IconButton>
         </div>
         <form onSubmit={handleSubmit(onSubmit)}>
            <Box
               display={'flex'}
               alignItems={'flex-start'}
               flexDirection={'column'}
               fontSize={20}
            >
               <Box display={'flex'} width={'100%'}>
                  <Grid container spacing={1}>
                     <Grid item xs={6}>
                        <TitleLabel>รหัสกระเป๋า</TitleLabel>
                        <Input
                           name={'walletCode'}
                           ref={register({ required: true })}
                           disabled
                        />
                     </Grid>
                     <Grid item xs={6}>
                        &nbsp;
                     </Grid>
                     <Grid item xs={12}>
                        <TitleLabel>ชื่อกระเป๋า</TitleLabel>
                        <Input
                           name={'walletNameTh'}
                           placeholder={'ชื่อกระเป๋าภาษาไทย'}
                           ref={register({ required: true })}
                        />
                     </Grid>
                     <Grid item xs={12}>
                        <Input
                           name={'walletNameEn'}
                           placeholder={'ชื่อกระเป๋าภาษาอังกฤษ'}
                           ref={register({ required: true })}
                        />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>
                           สถานะ
                           {errors.walletStatus && (
                              <AlertLabel>กรุณาเลือกสถานะ</AlertLabel>
                           )}
                        </TitleLabel>
                        <Controller
                           as={
                              <MySelect
                                 options={options}
                                 placeholder={'เลือกสถานะ'}
                                 closeMenuOnSelect
                                 colourStyles
                              />
                           }
                           rules={{ required: true }}
                           onChange={([selected]) => {
                              return selected;
                           }}
                           name='walletStatus'
                           control={control}
                        />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>
                           จำนวนคะแนนคงเหลือ
                           {(errors.pointAmount || errors.pointAmount) && (
                              <AlertLabel>
                                 {errors.pointAmount.message}
                              </AlertLabel>
                           )}
                        </TitleLabel>
                        <Controller
                           as={<Input textAlign={'right'} disabled />}
                           // rules={{
                           //   required: 'กรุณาระบุจำนวนคะแนน',
                           //   min: {
                           //     value: 1,
                           //     message: 'จำนวนคะแนนต้องมากกว่า 0',
                           //   },
                           // }}
                           onChange={([e]) => {
                              return new Intl.NumberFormat().format(
                                 e.target.value.replace(/[^0-9]/g, ''),
                              );
                           }}
                           name='pointAmount'
                           control={control}
                        />
                     </Grid>

                     <Grid item xs={12}>
                        <TitleLabel>รายละเอียด</TitleLabel>
                        <Input
                           name={'walletDescriptionTh'}
                           placeholder={'รายละเอียดภาษาไทย'}
                           ref={register({ required: true })}
                        />
                     </Grid>
                     <Grid item xs={12}>
                        <Input
                           name={'walletDescriptionEn'}
                           placeholder={'รายละเอียดภาษาอังกฤษ'}
                           ref={register({ required: true })}
                        />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>
                           วันหมดอายุ
                           {errors.walletExpiredDate && (
                              <AlertLabel>กรุณาเลือกวันหมดอายุ</AlertLabel>
                           )}
                        </TitleLabel>
                        <Box style={{ position: 'relative' }}>
                           <DatePicker
                              date={selectWalletExpiredDate}
                              onDateChange={handleWalletExpiredDate}
                              // locale={th}
                              locale={enUS}
                              minimumDate={new Date()}
                              // format="dd MMM yyyy"
                           >
                              {({ inputProps, focused }) => (
                                 <Input
                                    className={
                                       'input' + (focused ? ' -focused' : '')
                                    }
                                    {...inputProps}
                                    value={`${
                                       inputProps.value &&
                                       dayjs(new Date(inputProps.value)).format(
                                          'DD/MM/BBBB',
                                       )
                                    }`}
                                    placeholder={'เลือกวันที่'}
                                    readOnly
                                 />
                              )}
                           </DatePicker>
                        </Box>
                     </Grid>
                     <Grid item xs={12}>
                        <Box>
                           <Button
                              variant='contained'
                              color='primary'
                              type={'submit'}
                           >
                              ยืนยัน
                           </Button>
                           <Button
                              variant='contained'
                              onClick={props.onClickClose}
                           >
                              ยกเลิก
                           </Button>
                        </Box>
                     </Grid>
                  </Grid>
               </Box>
            </Box>
         </form>
      </Paper>
   );
}

export default Edit;
